<template>
  <div>
    <div v-if="cellData.entries">
      <div v-for="(entry, index) in cellData.entries" :index="index" :key="entry">
        n = {{ entry.NumberOfShopsTotal }}
      </div>
    </div>
    <div v-if="hasNumberOfShopsTotal() && !cellData.entries" class="bccell">
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[1] && cellData.SurveyWave[1].NumberOfShopsTotal" class="bccellaw">
        n = {{ cellData.SurveyWave[1].NumberOfShopsTotal }}
      </div>
      <div  v-else-if="cellData.SurveyWave.length === 1 && cellData.SurveyWave[0] && cellData.SurveyWave[0].NumberOfShopsTotal" class="bccelllw" >
        n = {{ cellData.SurveyWave[0].NumberOfShopsTotal }}
      </div>
      <div  v-else style="width: 0%; height: 1rem;" />
      <div  v-if="cellData.SurveyWave.length > 1 && cellData.SurveyWave[0] && cellData.SurveyWave[0].NumberOfShopsTotal" class="bccelllw" >
        n = {{ cellData.SurveyWave[0].NumberOfShopsTotal }}
      </div>
      <div  v-else class="bccellnow" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    hasNumberOfShopsTotal() {
      if (!this.cellData || !this.cellData.SurveyWave || !this.cellData.SurveyWave[0]) {
        return false;
      }
      if (!this.cellData.SurveyWave[0].NumberOfShopsTotal) {
        return false;
      }
      return true;
    }
  }

};
</script>
<style scoped>

.bccell{
  width: 100%;
  height: 2rem;
}
.bccelllw, .bccellaw, .bccellnow {
  height: 1rem;
}

.bccellnow {
  width: 0%;
}

</style>
